import script from "./SignCla.vue?vue&type=script&setup=true&lang=js"
export * from "./SignCla.vue?vue&type=script&setup=true&lang=js"

import "./SignCla.vue?vue&type=style&index=0&id=296e2019&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296e2019"]])

export default __exports__